const cardSliders = document.querySelectorAll('[data-slider="card-slider"]');

const cardSliderOptions = {
  slidesPerView: 'auto',
  spaceBetween: 0,
  speed: 800,
  breakpoints: {
    768: {
      spaceBetween: 20,
    },
  },
};

cardSliders.forEach((el) => {
  const cardSlider = new Swiper(el, cardSliderOptions);
  swiperLockClass(el, cardSlider);
});
